import 'nodelist-foreach-polyfill';
import 'classlist-polyfill';
import 'element-closest-polyfill';

import VixclickLayer from './js/vix-click-layer';
import VixSelectChange from './js/vix-select-change';
import VixSticky from './js/vix-sticky';
import VixCloseRecruit from './js/vix-close-recruit';
import VixUtily from './js/vix-utility';

// input file
const formInputFile = function(el) {
    const fileAttach = document.querySelectorAll(el),
        fileAttachCnt = fileAttach.length;

    for(let i = 0; i < fileAttachCnt; i++) {
        const trgInputFile = fileAttach[i].querySelector('.upload_hidden');

        trgInputFile.onchange = function() {
            let filename = this.value.split(/(\\|\/)/g).pop(),
                trgInputText = this.parentNode.querySelector('.upload_text');

            trgInputText.value = filename;
        };
    }
};

document.addEventListener("DOMContentLoaded", function() {
    const elBtnOpen = document.querySelectorAll('[data-click-open]'), //바닥페이지에 토글 레이어 컨트롤
        elBtnClose = document.querySelectorAll('[data-click-close]'), //바닥페이지에 토글 레이어 컨트롤
        selectChange = document.querySelectorAll('.evaluate .inpSel select'),
        stickyEl = document.querySelectorAll('[data-fixed]'),
        lnbRecruitLayer = document.querySelector('.wrap_recruit_frm .title_recruit');

    if(selectChange.length) {
        new VixSelectChange(selectChange);
    }

    if(elBtnOpen.length && elBtnClose.length) {
        new VixclickLayer(elBtnOpen, elBtnClose);
    }
    // 툴팁
    const tooltipOver = document.querySelectorAll('.toolTipWrap.over'),
        tooltipClick = document.querySelectorAll('.toolTipWrap.click');

    if(tooltipOver.length) {
        UI.Tooltip(tooltipOver, {
            eventType : 'mouseenter',
            setPosition : true
        });
    }
    if(tooltipClick.length) {
        UI.Tooltip(tooltipClick, {
            closeOthers : true,
            setPosition : true
        });
    }

    if(stickyEl.length == 1) {
        new VixSticky('#content');
    }
    // close lnb recruit layer
    if(lnbRecruitLayer) {
        new VixCloseRecruit(lnbRecruitLayer);
    }
    new VixUtily();
});
export {
    VixSticky
}


